import React from "react";
import styled from "styled-components";
import MainNav from "../components/navbar/MainNav";

export default function TermOfService() {
  return (
    <>
      <MainNav />
      <Main>
        <div className="content">
          <h4>TERMS AND CONDITIONS</h4>
          <p className="effective-date"><strong>Effective Date: 08/01/2025</strong></p>

          <h5>Welcome to WROOT</h5>
          <p>
            By accessing and utilizing the WROOT website (wrootapp.com) and associated services, you explicitly agree to comply with and be legally bound by the following comprehensive Terms and Conditions. Please read these terms carefully before using the services.
          </p>

          <h5>1. Eligibility and Registration</h5>
          <p>
            To access certain services provided by WROOT, users are required to create an account. By creating an account, you represent and warrant that all information provided is accurate, truthful, and current. WROOT reserves the right to suspend or terminate accounts at its sole discretion if the information provided is found to be inaccurate, misleading, or fraudulent.
          </p>

          <h5>2. Sign-Up Welcome Package</h5>
          <p>
            New subscribers or registered users may receive a promotional welcome package, generally including:
          </p>
          <ul>
            <li>One (1) branded WROOT t-shirt;</li>
            <li>Assorted recycled and sustainably sourced tokens or keepsakes.</li>
          </ul>
          <p>
            The welcome package is subject to availability and may vary based on inventory and regional logistics. Items included in this package hold no monetary value, are non-exchangeable, non-refundable, and not eligible for return.
          </p>

          <h5>3. Project Funding and Execution</h5>
          <p>
            WROOT employs a transparent, meter-based funding system for earth-centric projects. Each project will begin implementation only upon achieving 100% of its specified funding goal, clearly displayed via a percentage-based progress meter on the website.
          </p>
          <p>
            Funds contributed prior to achieving full funding will be securely held in escrow. If a project fails to reach its funding goal within the stated timeframe, WROOT reserves the exclusive right to redistribute funds to alternative similar environmental projects or issue refunds at its sole discretion.
          </p>

          <h5>4. Engineering Solutions</h5>
          <p>
            WROOT is a science-driven organization founded and operated by professional engineers. As part of our commitment to impactful ecological restoration, we employ advanced technological solutions, including but not limited to robotics, artificial intelligence (AI), and engineering methodologies, to address pressing environmental concerns. While these engineering solutions are developed with rigorous professional standards, users acknowledge and agree that:
          </p>
          <p>
            <strong>Experimental Nature:</strong> Some engineering initiatives may be experimental or innovative in nature. Although we adhere to the highest standards of safety and effectiveness, outcomes of innovative or experimental technologies inherently carry uncertainties.
          </p>
          <p>
            <strong>No Guarantees:</strong> WROOT does not provide explicit or implicit guarantees concerning the outcomes, effectiveness, or long-term impact of these engineering-based initiatives.
          </p>
          <p>
            <strong>Limitation of Liability:</strong> To the fullest extent permitted by Nevada law, users expressly agree that WROOT and its affiliates, directors, employees, agents, or engineers shall not be liable for any direct, indirect, consequential, or incidental damages arising from or related to the implementation or outcomes of any engineering solution, robotics application, or AI-driven initiative employed by WROOT.
          </p>
          <p>
            By engaging with WROOT and supporting our engineering-driven projects, you explicitly consent to and accept the inherent risks and experimental nature associated with innovative technology applications in environmental restoration efforts.
          </p>

          <h5>5. User Engagement, Transparency, and Communication</h5>
          <p>
            Upon project initiation, contributors will receive:
          </p>
          <ul>
            <li>Periodic project updates detailing milestones, supported by visual documentation (e.g., photographs, video);</li>
            <li>Personalized tokens of appreciation for ongoing support.</li>
          </ul>

          <h5>6. Intellectual Property Rights</h5>
          <p>
            Majority of website content; including text, graphics, logos, trademarks, images, and other intellectual property; is exclusively owned or licensed by WROOT. Unauthorized reproduction, distribution, modification, or usage of content without express written consent from WROOT is strictly prohibited.
          </p>

          <h5>7. Limitation of Liability</h5>
          <p>
            You expressly acknowledge and agree that your use of the WROOT website and services is at your own risk. To the fullest extent permitted by applicable law, WROOT shall not be liable for any direct, indirect, incidental, consequential, punitive, special, or exemplary damages arising out of or in connection with your use or inability to use the services or your reliance on the information provided.
          </p>

          <h5>8. Indemnification</h5>
          <p>
            You agree to indemnify, defend, and hold harmless WROOT, its affiliates, officers, directors, employees, and agents from and against all claims, liabilities, damages, losses, or expenses, including reasonable attorney's fees and costs, arising out of or connected with your violation of these Terms and Conditions or your misuse of the WROOT platform and services.
          </p>

          <h5>9. Modifications to Terms and Conditions</h5>
          <p>
            WROOT reserves the right to update, modify, or revise these Terms and Conditions at any time without prior notice. Such changes will be prominently displayed on our website. Continued use after such changes indicates your acceptance of the revised terms.
          </p>

          <h5>10. Governing Law and Jurisdiction</h5>
          <p>
            These Terms and Conditions shall be governed by and interpreted according to the laws of the State of Nevada, without regard to conflicts of law principles. Users consent to the exclusive jurisdiction and venue of the courts located within Clark County, Nevada, for the resolution of any disputes arising from these Terms.
          </p>

          <h5>11. Severability</h5>
          <p>
            If any provision of these Terms and Conditions is found to be invalid or unenforceable, such provision will be deemed severable and will not affect the validity or enforceability of the remaining provisions.
          </p>

          <h5>12. Entire Agreement</h5>
          <p>
            These Terms and Conditions constitute the entire agreement between you and WROOT regarding your use of the services and supersede all prior and contemporaneous understandings or agreements.
          </p>

          <h5>13. Contact Information</h5>
          <p>
            For any questions, concerns, or clarifications regarding these Terms and Conditions, please contact us at:
          </p>
          <ul>
            <li>Email: support@wrootapp.com</li>
            <li>Address: 5893 HONEYSUCKLE RIDGE ST, LAS VEGAS, NV, 89148, USA</li>
            <li>Phone: [Contact information available upon request]</li>
          </ul>

          <p className="closing">
            Thank you for your cooperation and support in advancing WROOT's global environmental restoration and sustainability mission.
          </p>
        </div>
      </Main>
    </>
  );
}

const Main = styled.div`
  max-width: 800px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  border-radius: var(--s-radius);
  margin: var(--section-margin) auto;
  min-height: var(--section-height);

  .content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    flex-direction: column;
    padding: 20px;
    h4 {
      font-weight: bold;
    }
    h5 {
      font-weight: 600;
    }
    p {
      color: var(--text-light-color);
    }
    
    .effective-date {
      font-size: 1.1rem;
      margin-bottom: 2rem;
      color: var(--text-light-color);
    }
    
    ul {
      margin: 1rem 0;
      padding-left: 1.5rem;
      
      li {
        margin-bottom: 0.5rem;
        color: var(--text-light-color);
      }
    }
    
    .closing {
      margin-top: 2rem;
      font-style: italic;
      font-weight: 500;
      color: var(--primary-color);
    }
  }
`;
